module.exports = __webpack_public_path__ + "img/1466894183.1c3f3920.jpg";